// @flow
import { AccommodationsActionTypes } from './constants';

type AccommodationsAction = { type: string, payload: {} | string };

// common success
export const accommodationsApiResponseSuccess = (actionType: string, data: any): AccommodationsAction => ({
    type: AccommodationsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const accommodationsApiResponseError = (actionType: string, error: string): AccommodationsAction => ({
    type: AccommodationsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getAccommodation = (id: string): AccommodationsAction => ({
    type: AccommodationsActionTypes.GET_ACCOMMODATION,
    payload: { id },
});

export const addAccommodation = (accommodation: any): AccommodationsAction => ({
    type: AccommodationsActionTypes.ADD_ACCOMMODATION,
    payload: accommodation
})
export const updateAccommodation = (accommodation: any): AccommodationsAction => ({
    type: AccommodationsActionTypes.UPDATE_ACCOMMODATION,
    payload: accommodation
})
export const deleteAccommodation = (id: string): AccommodationsAction => ({
    type: AccommodationsActionTypes.DELETE_ACCOMMODATION,
    payload: { id }
})

export const listAccommodations = (params: any): AccommodationsAction => ({
    type: AccommodationsActionTypes.LIST_ACCOMMODATIONS,
    payload: params,
});

export const getAccommodationCharts = (params: any): AccommodationsAction => ({
    type: AccommodationsActionTypes.GET_ACCOMMODATION_CHARTS,
    payload: params,
});

export const getAccommodationsForExcel = (params: any): AccommodationsAction => ({
    type: AccommodationsActionTypes.GET_ACCOMMODATIONS_FOR_EXCEL,
    payload: params,
});

export const resetAccommodations = (): AccommodationsAction => ({
    type: AccommodationsActionTypes.RESET,
    payload: {},
});

